import React from "react";

export default function Services() {
    return (
        <>
            <h1 class="heading"> our
                <span> services</span> </h1>

            <div class="box-container">

                <div class="box">
                    <img src="images/service-1.png" alt="" />
                    <h3>House construction</h3>
                    <p>P2Construction provides complete end-to-end home construction services. From Site Analysis, Topographical Site Survey, Soil Test to complete interior design and finishing such as flooring, painting, fixtures for all rooms, etc., </p>
                </div>

                <div class="box">
                    <img src="images/service-5.png" alt="" />
                    <h3>building renovation</h3>
                    <p>Revitalize your space with our premier building renovation services. From modernizing interiors to enhancing structural integrity, we specialize in transforming properties into stunning, functional spaces.</p>


                </div>

                <div class="box">
                    <img src="images/service-2.png" alt="" />
                    <h3>House renovation</h3>
                    <p><font >As a top home renovation company in Mandya, we renovate complete spaces to individual areas in your home or in a commercial building. We also provide best floor addition services to your existing building with complete structural analysis.</font></p>
                </div>

                <div class="box">
                    <img src="images/service-6.png" alt="" />
                    <h3>Interior design</h3>
                    <p>
                        <font >Using modern fixtures, unique designs and creative thinking, we provide the best interior design solutions which helps in enhancing your overall living space. As one of the best architects and builders in Bangalore, our construction services combined with interior services helps in avoiding unnecessary rework.</font>
                    </p>
                </div>

            </div>
        </>
    )
}